import { LanguageCode } from '@/enums/languageCode';

export type BannerLocaleCopy = {
  title: string;
  body: string;
  ctaLabel: string;
  ctaLink: string;
  dismissLabel: string;
};

export type BannerConfig = {
  id: string;
  translations: Record<LanguageCode, BannerLocaleCopy>;
};

export const BANNER_REGISTRY: readonly BannerConfig[] = [
  {
    id: 'welcome',
    translations: {
      [LanguageCode.EN]: {
        title: 'Why Chirpy feedback?',
        body: 'Regular feedback helps build stronger teams and drives continuous improvement. With Chirpy feedback, you can create a culture of open communication and growth.',
        ctaLabel: 'Learn more',
        ctaLink: 'https://www.chirpee.co',
        dismissLabel: 'Hide this message',
      },
      [LanguageCode.FR]: {
        title: 'Pourquoi Chirpy feedback ?',
        body: 'Des retours réguliers renforcent les équipes et favorisent l’amélioration continue. Avec Chirpy feedback, vous créez une culture de communication ouverte et de progression.',
        ctaLabel: 'En savoir plus',
        ctaLink: 'https://www.chirpee.co/fr',
        dismissLabel: 'Masquer ce message',
      },
      [LanguageCode.ES]: {
        title: '¿Por qué Chirpy feedback?',
        body: 'La retroalimentación periódica ayuda a formar equipos más sólidos e impulsa la mejora continua. Con Chirpy feedback puede fomentar una cultura de comunicación abierta y crecimiento.',
        ctaLabel: 'Más información',
        ctaLink: 'https://www.chirpee.co/es',
        dismissLabel: 'Ocultar este mensaje',
      },
      [LanguageCode.DE]: {
        title: 'Warum Chirpy Feedback?',
        body: 'Regelmäßiges Feedback stärkt Teams und fördert kontinuierliche Verbesserung. Mit Chirpy Feedback schaffen Sie eine Kultur offener Kommunikation und Weiterentwicklung.',
        ctaLabel: 'Mehr erfahren',
        ctaLink: 'https://www.chirpee.co/de',
        dismissLabel: 'Diese Nachricht ausblenden',
      },
      [LanguageCode.SV]: {
        title: 'Varför Chirpy feedback?',
        body: 'Regelbunden återkoppling bygger starkare team och driver ständig förbättring. Med Chirpy feedback kan ni skapa en kultur av öppen kommunikation och utveckling.',
        ctaLabel: 'Läs mer',
        ctaLink: 'https://www.chirpee.co/sv',
        dismissLabel: 'Dölj det här meddelandet',
      },
    },
  },
];

export function bannerLanguageFromI18n(i18nLanguage: string | undefined): LanguageCode {
  const base = i18nLanguage?.split('-')[0]?.toLowerCase();
  if (base && (Object.values(LanguageCode) as string[]).includes(base)) {
    return base as LanguageCode;
  }
  return LanguageCode.EN;
}

export function pickBannerCopy(config: BannerConfig, language: LanguageCode): BannerLocaleCopy {
  return config.translations[language] ?? config.translations[LanguageCode.EN];
}
